import { ErrorRequestResponse, SuccessRequestResponse } from '@trimble/types';

export const handleResult = <G, Err>(
  response: SuccessRequestResponse<G> | ErrorRequestResponse<Err>
): G | Error => {
  if (response.data !== undefined) {
    return response.data;
  } else if (response.error !== undefined) {
    console.log(response.error); // TODO: Replace with proper logging / error handling
    return new Error('Request failed.', { cause: response.error }); // TODO: Translation
  } else {
    throw new Error('Invalid response format');
  }
};
